import { render, staticRenderFns } from "./IconTextComponent.vue?vue&type=template&id=5acd46d7&"
import script from "./IconTextComponent.vue?vue&type=script&lang=ts&"
export * from "./IconTextComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5acd46d7')) {
      api.createRecord('5acd46d7', component.options)
    } else {
      api.reload('5acd46d7', component.options)
    }
    module.hot.accept("./IconTextComponent.vue?vue&type=template&id=5acd46d7&", function () {
      api.rerender('5acd46d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IconTextComponent.vue"
export default component.exports